(function () {
  'use strict';
  function money(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch (_) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }
  function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
  var subscriptionSelected = false;
  function updateAnnouncement() {
    var promotion = window.BCJPromotion && window.BCJPromotion.details();
    var announcementBar = document.querySelector('[data-bcj-announcement-bar]');
    document.querySelectorAll('[data-bcj-promotion-announcement]').forEach(function (node) {
      // Reuse the top bar so its existing sticky behavior and height tracking stay in control.
      if (announcementBar && !announcementBar.contains(node)) {
        announcementBar.insertBefore(node, announcementBar.firstChild);
      }
      node.hidden = !promotion || !promotion.active || subscriptionSelected;
      if (announcementBar) announcementBar.classList.toggle('has-bcj-promotion', !node.hidden);
      if (promotion && promotion.active) text(node.querySelector('[data-bcj-announcement-percent]'), promotion.percent + '%');
    });
  }
  window.addEventListener('bcj:purchase-type:change', function (event) {
    subscriptionSelected = Boolean(event.detail && event.detail.subscription);
    updateAnnouncement();
  });
  function initialize() {
    updateAnnouncement();
    document.querySelectorAll('[data-bcj-legacy-product]').forEach(function (root) {
      if (root.bcjPromotionInitialized) return;
      var variants;
      try { variants = JSON.parse(root.dataset.bcjVariants); } catch (_) { return; }
      root.bcjPromotionInitialized = true;
      var pending = false;
      function refresh() {
        pending = false;
        if (!root.isConnected) return;
        var input = root.querySelector('[name="id"]');
        var variant = variants.find(function (item) { return String(item.id) === String(input && input.value); }) || variants[0];
        if (!variant) return;
        var plan = root.querySelector('[name="selling_plan"]:checked') || root.querySelector('select[name="selling_plan"], input[type="hidden"][name="selling_plan"]');
        var sellingPlanId = plan && !plan.disabled ? plan.value : '';
        if (String(sellingPlanId) === '0') sellingPlanId = '';
        // Hidden quickview forms must not override the main PDP's purchase option.
        if (root.dataset.modal !== 'true') {
          subscriptionSelected = Boolean(sellingPlanId);
          updateAnnouncement();
        }
        var base = variant.price;
        var allocations = root.querySelector('[data-bcj-plan-prices]');
        if (sellingPlanId && allocations) {
          try {
            var prices = JSON.parse(allocations.textContent);
            var planKey = String(variant.id) + ':' + sellingPlanId;
            if (Object.prototype.hasOwnProperty.call(prices, planKey)) base = prices[planKey];
          } catch (_) {}
        }
        var promotion = window.BCJPromotion && window.BCJPromotion.details({handle: root.dataset.productHandle, variantId: variant.id, price: base, sellingPlanId: sellingPlanId});
        var price = promotion ? promotion.price : base;
        var active = !sellingPlanId && price < base;
        var compare = active || sellingPlanId ? variant.price : variant.compare_at_price;
        root.querySelectorAll('.product-block--price').forEach(function (block) {
          var priceEl = block.querySelector('[data-product-price]');
          if (!priceEl) return;
          var compareWrap = block.querySelector('[data-product-price-wrap]');
          if (!compareWrap) {
            compareWrap = document.createElement('span');
            compareWrap.setAttribute('data-product-price-wrap', '');
            compareWrap.innerHTML = '<span data-compare-price class="product__price product__price--compare"></span> ';
            priceEl.before(compareWrap);
          }
          var onSale = compare > price;
          text(priceEl, money(price));
          priceEl.classList.toggle('on-sale', onSale);
          compareWrap.classList.toggle('hide', !onSale);
          text(compareWrap.querySelector('[data-compare-price]'), onSale ? money(compare) : '');
          var regularLabel = block.querySelector('[data-a11y-price]');
          if (regularLabel) regularLabel.setAttribute('aria-hidden', onSale ? 'false' : 'true');
          var saleLabel = block.querySelector('[data-compare-price-a11y]');
          if (!saleLabel) {
            saleLabel = document.createElement('span');
            saleLabel.setAttribute('data-compare-price-a11y', '');
            saleLabel.className = 'visually-hidden';
            priceEl.before(saleLabel);
          }
          text(saleLabel, onSale ? 'Sale price' : 'Price');
          var existingSavings = block.querySelector('[data-save-price]');
          if (existingSavings) {
            existingSavings.classList.toggle('hide', !onSale);
            var savings = window.theme && window.theme.settings && window.theme.settings.saveType !== 'dollar'
              ? Math.round((compare - price) * 100 / compare) + '%' : money(compare - price);
            text(existingSavings, onSale ? 'Save ' + savings : '');
          }
          var label = block.querySelector('[data-bcj-sale-label]');
          if (!label) {
            label = document.createElement('div');
            label.setAttribute('data-bcj-sale-label', '');
            label.className = 'bcj-promotion-label';
            priceEl.after(label);
          }
          label.hidden = !active;
          text(label, active ? 'Beefcake Days · ' + promotion.percent + '% off one-time purchases' : '');
        });
      }
      function schedule() { if (!pending) { pending = true; requestAnimationFrame(refresh); } }
      root.addEventListener('change', schedule);
      root.addEventListener('variantChange', schedule);
      root.addEventListener('variantPriceChange', schedule);
      window.addEventListener('bcj:promotion:change', schedule);
      var observer = new MutationObserver(schedule);
      observer.observe(root, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value', 'disabled', 'checked']});
      refresh();
    });
    document.querySelectorAll('[data-bcj-static-price]').forEach(function (node) {
      var original = Number(node.dataset.bcjStaticPrice);
      var price = window.BCJPromotion ? window.BCJPromotion.price({handle: node.dataset.productHandle, variantId: node.dataset.variantId, price: original}) : original;
      text(node, money(price));
      node.classList.toggle('bcj-promotion-price', price < original);
    });
  }
  window.addEventListener('bcj:promotion:change', initialize);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('quickview:loaded', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
})();
